import React from "react";

export const TasksContext = React.createContext<{
  setTerminalTasks?: (progress: number) => void;
  setTotalTasks?: (count: number) => void;
  terminalTasks: number;
  totalTasks: number;
}>({ terminalTasks: 0, totalTasks: 0 });
